import { Link } from 'react-router-dom';

interface ArticleCardProps {
  title: string;
  excerpt: string;
  image: string;
  category: string;
  categorySlug: string;
  date: string;
  readTime: number;
  slug: string;
}

export default function ArticleCard({
  title,
  excerpt,
  image,
  category,
  categorySlug,
  date,
  readTime,
  slug,
}: ArticleCardProps) {
  return (
    <Link
      to={`/article/${slug}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="aspect-[16/10] overflow-hidden relative">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute top-3 left-3">
          <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500 text-background-50">
            {category}
          </span>
        </div>
      </div>
      <div className="p-5">
        <h3 className="text-base font-heading font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
          {title}
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 mb-4 leading-relaxed">
          {excerpt}
        </p>
        <div className="flex items-center gap-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line" />
            {date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line" />
            {readTime} 分钟阅读
          </span>
        </div>
      </div>
    </Link>
  );
}